module.exports = __webpack_public_path__ + "static/media/offroad.9d28d616.svg";